import {
  apiCaller,
  checkStatusResponse,
  fromBreadcrumbObjectToString,
  notifyToast,
} from "../helpers";
import { setStateAdmin } from "./admins";
import _ from "lodash";

const initialState = {
  Post: {},
  Categories: {},
  isCategories: false,
  listParentCategoriesVi: [],
  listParentCategoriesEn: [],
  listParent: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_STATE_POST":
      return Object.assign({}, state, {
        [action.propertyName]: action.value,
      });
    case "SET_MULTIPLE_STATE_POST":
      return Object.assign({}, state, action.newObject);
    default:
      return state;
  }
}

// set state dashboard
export function setStatePost(propertyName, value) {
  return {
    type: "SET_STATE_POST",
    propertyName,
    value,
  };
}

// set multi dashboard
export function setMultipleStatePost(newObject) {
  return {
    type: "SET_MULTIPLE_STATE_POST",
    newObject,
  };
}

export function getPost(page, pageSize, query, langId, categoryId, status) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/post/getallpost?queryString=${query}&userName=null&pageIndex=${page}&pageSize=${pageSize}&langId=${langId}&categoryId=${categoryId}&status=${status}`,
        "GET",
        null
      );
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      dispatch(setStatePost("Post", res.data.response));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function toggleStatus(body) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(`/api/post/updatestatuspost`, "PUT", body);
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Cập nhật trạng thái thành công");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function addPost(body) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(`/api/post/addpost`, "POST", body);
      console.log(res);
      dispatch(setStateAdmin("loading", false));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function deletePost(postId) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/post/deletepost?postId=${postId}`,
        "DELETE",
        null
      );
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Xóa bài viết thành công!");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

// categories
export function getCategories(page, pageSize, query, langId) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/category/getallcategory?queryString=${query}&pageIndex=${page}&pageSize=${pageSize}&langId=${langId}&userId=`,
        "GET",
        null
      );
      // console.log(res);
      const { response } = res.data;
      const arrVi = _.filter(response.data, (item) => {
        return item.langId === 1;
      });
      const arrEn = _.filter(response.data, (item) => {
        return item.langId === 2;
      });
      dispatch(setStateAdmin("loading", false));
      dispatch(
        setMultipleStatePost({
          Categories: response,
          isCategories: false,
          listParentCategoriesVi: arrVi,
          listParentCategoriesEn: arrEn,
        })
      );
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function deleteCategories(categoryId) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/category/deletecategory?categoryId=${categoryId}`,
        "DELETE",
        null
      );
      // console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Xóa chuyên mục thành công!");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function getParentCategories(langId) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/category/getcategorytreebylangId?langId=${langId}&pageSize=99999`,
        "GET",
        null
      );
      const { response } = res.data;

      dispatch(setStateAdmin("loading", false));
      if (_.isEmpty(response.data)) {
        dispatch(setStatePost("listParent", []));
      } else {
        let target = response.data.map((o) => {
          let label2 = fromBreadcrumbObjectToString(o, " >> ");
          o.label = label2;
          return o;
        });
        dispatch(setStatePost("listParent", target));
      }
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}
